import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';

import type { UnitPrecision, UnitType } from './types';
import { valueFormatter } from './value-formatter';

@Pipe({
  name: 'rtUnitTypeFormatterPipe',
  pure: true,
  standalone: true,
})
export class UnitTypeFormatterPipe implements PipeTransform {
  constructor(private i18n: I18nService) {}

  public transform(
    value: string | number,
    options: { unitPrecision: UnitPrecision; unitType: UnitType },
  ): string {
    return valueFormatter(value, options, this.i18n);
  }
}
